import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

import { AdsComponent } from './ads.component';
import { RouterModule } from '@angular/router';

@NgModule({
    declarations: [
        AdsComponent
    ],
    imports: [
        CommonModule,
        IonicModule,
        RouterModule
    ],
    exports: [AdsComponent],
    providers: [],
})
export class AdsModule { }
